module.exports = __webpack_public_path__ + "img/trash.1576aec4.svg";